import React from 'react';
import {externalUrl} from '../../utils';
import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import IconTwitter from '../icon/IconTwitter';
import IconLinkedin from '../icon/IconLinkedin';
import IconFacebook from '../icon/IconFacebook';
import IconGoogle from '../icon/IconGoogle';

export default function SocialLoginForm() {
  const styles = createUseStyles({
    twitter: {
      background: '#05ACED',
    },
    facebook: {
      background: '#3A5A97',
    },
    linkedin: {
      background: '#016599',
    }
  })();
  return (
    <div>
      <div className="flex flex-col">
        <a
          href={externalUrl('/authenticate/twitter')}
          className={cn('my-2 w-full inline-flex justify-center py-2.5 px-4 rounded-md text-white relative', styles.twitter)}
        >
          <IconTwitter className="w-5 h-5 absolute left-4 mt-0.5"/>
          <span>Login with Twitter</span>
        </a>

        <a
          href={externalUrl('/authenticate/facebook')}
          className={cn('my-2 w-full inline-flex justify-center py-2.5 px-4 rounded-md text-white relative', styles.facebook)}
        >
          <IconFacebook className="w-5 h-5 absolute left-4 mt-0.5"/>
          <span>Login with Facebook</span>
        </a>

        <a
          href={externalUrl('/authenticate/linkedin')}
          className={cn('my-2 w-full inline-flex justify-center py-2.5 px-4 rounded-md text-white relative', styles.linkedin)}
        >
          <IconLinkedin className="w-5 h-5 absolute left-4 mt-0.5"/>
          <span>Login with LinkedIn</span>
        </a>

        <a
          href={externalUrl('/authenticate/google')}
          className='my-2 w-full inline-flex justify-center py-2.5 px-4 rounded-md border border-gray relative'
        >
          <IconGoogle className="w-5 h-5 absolute left-4 mt-0.5"/>
          <span>Login with Google</span>
        </a>

      </div>
    </div>
  )
}
